/* eslint-disable */
export enum SessionActionTypes {
  SET_LOGGED_IN = "@@Session/SET_LOGGED_IN",
  SET_LOGIN_STEP = "@@Session/SET_LOGIN_STEP",
  SET_REGISTER_STEP = "@@Session/SET_REGISTER_STEP",
  SET_NAME_VALIDATION_MODAL = "@@Session/SET_NAME_VALIDATION_MODAL"
}

export default SessionActionTypes;